import { createFileRoute } from "@tanstack/react-router";
import { CelebrityResultPage } from "@/components/site/CelebrityResultPage";
import { deionSanders } from "@/lib/celebrity-results/deion-sanders";
import { absoluteUrl } from "@/lib/absolute-url";

const TITLE = "Deion Sanders Hair Transplant Results | RESTORE® Hair";
const DESC = "See Hall of Famer Deion Sanders' RESTORE® No-Shave FUE™ hair transplant results, before & after photos and his full hair restoration story.";
const POSTER = "/img/r/wp-2023-11-restore-seamless-hr-5321-v2-copy-1kraked-new-1.webp";

export const Route = createFileRoute("/results/deion-sanders")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESC },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESC },
      { property: "og:type", content: "article" },
      { property: "og:url", content: "https://restorehair.com/results/deion-sanders/" },
      { property: "og:image", content: absoluteUrl(POSTER) },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:image", content: absoluteUrl(POSTER) },
    ],
    links: [
      { rel: "canonical", href: "https://restorehair.com/results/deion-sanders/" },
    ],
  }),
  component: () => <CelebrityResultPage data={deionSanders} />,
});
